var _FontAwesomeIcon, _FontAwesomeIcon2;
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
var styles = {
  "wrapper": "pbui-fQ5BR",
  "previous--wrapper": "pbui-jeuSB",
  "previous--wrapper--disabled": "pbui-NXmc5",
  "previous--wrapper--enabled": "pbui-bhqHe",
  "previous--text": "pbui-Z3Pxh",
  "pages--wrapper": "pbui-6Qlcv",
  "page--wrapper": "pbui-BeBdC",
  "page--wrapper--selected": "pbui-4FOGu",
  "page--wrapper--regular": "pbui-IIA3c",
  "page--wrapper--separator": "pbui-H0G5E",
  "page--wrapper--not--separator": "pbui-1kW-p",
  "page--text": "pbui-sQHEV",
  "page--wrapper--centered": "pbui-Vaugc",
  "page--wrapper--white": "pbui-1i-Ht"
};
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// 0 <= currentPage <= totalNumberOfPage is valid scope for currentPage
// Why 0? Well when currentPage is 0, then no page is selected
var PaginationV2 = function PaginationV2(_ref) {
  var totalNumberOfPages = _ref.totalNumberOfPages,
    currentPage = _ref.currentPage,
    onPreviousClick = _ref.onPreviousClick,
    onPageClick = _ref.onPageClick,
    onNextClick = _ref.onNextClick,
    _ref$customSeparator = _ref.customSeparator,
    customSeparator = _ref$customSeparator === void 0 ? '...' : _ref$customSeparator;
  if (totalNumberOfPages < 1 || currentPage < 0 || totalNumberOfPages < currentPage) {
    return null;
  }
  var getPageNumbers = function getPageNumbers() {
    if (totalNumberOfPages <= 5) {
      return Array.from({
        length: totalNumberOfPages
      }, function (_, i) {
        return i + 1;
      });
    }
    if (currentPage < 3) {
      return [1, 2, 3, customSeparator, totalNumberOfPages];
    }
    if (currentPage === 3) {
      return [1, 2, 3, 4, customSeparator, totalNumberOfPages];
    }
    if (currentPage > totalNumberOfPages - 2) {
      return [1, customSeparator, totalNumberOfPages - 2, totalNumberOfPages - 1, totalNumberOfPages];
    }
    if (currentPage === totalNumberOfPages - 2) {
      return [1, customSeparator, totalNumberOfPages - 3, totalNumberOfPages - 2, totalNumberOfPages - 1, totalNumberOfPages];
    }
    return [1, customSeparator, currentPage - 1, currentPage, currentPage + 1, customSeparator, totalNumberOfPages];
  };
  var previousWrapperClasses = clsx(styles['previous--wrapper'], (currentPage === 1 || currentPage === 0) && styles['previous--wrapper--disabled'], currentPage > 1 && styles['previous--wrapper--enabled']);
  var nextWrapperClasses = clsx(styles['previous--wrapper'], currentPage === totalNumberOfPages && styles['previous--wrapper--disabled'], currentPage < totalNumberOfPages && styles['previous--wrapper--enabled']);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['wrapper'],
    children: [/*#__PURE__*/_jsxs("button", {
      onClick: function onClick() {
        return currentPage > 1 && onPreviousClick && onPreviousClick();
      },
      disabled: currentPage === 1 || currentPage === 0,
      className: previousWrapperClasses,
      children: [_FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowLeft,
        width: 12
      })), /*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Previous"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['pages--wrapper'],
      children: getPageNumbers().map(function (page, index) {
        return /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return typeof page === 'number' && onPageClick && onPageClick(page);
          },
          className: "".concat(styles['page--wrapper'], " ").concat(currentPage === page ? styles['page--wrapper--selected'] : styles['page--wrapper--regular'], " ").concat(page === customSeparator ? styles['page--wrapper--separator'] : styles['page--wrapper--not--separator']),
          children: /*#__PURE__*/_jsx("span", {
            className: styles['page--text'],
            children: page
          })
        }, index);
      })
    }), /*#__PURE__*/_jsxs("button", {
      onClick: function onClick() {
        return currentPage < totalNumberOfPages && onNextClick && onNextClick();
      },
      disabled: currentPage === totalNumberOfPages,
      className: nextWrapperClasses,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles['previous--text'],
        children: "Next"
      }), _FontAwesomeIcon2 || (_FontAwesomeIcon2 = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faArrowRight,
        width: 12
      }))]
    })]
  });
};
export default PaginationV2;